import { render, staticRenderFns } from "./bulletinDetail.vue?vue&type=template&id=b6c9756a&scoped=true"
import script from "./bulletinDetail.vue?vue&type=script&lang=js"
export * from "./bulletinDetail.vue?vue&type=script&lang=js"
import style0 from "./bulletinDetail.vue?vue&type=style&index=0&id=b6c9756a&prod&lang=css"
import style1 from "../../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=b6c9756a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c9756a",
  null
  
)

export default component.exports